export const BUDGETREPORTLIST_SEARCH = 'BUDGETREPORTLIST_SEARCH';
export const BUDGETREPORTLIST_PAGE = 'BUDGETREPORTLIST_PAGE';
export const BUDGETREPORTLIST_STARTDATE = 'BUDGETREPORTLIST_STARTDATE';
export const BUDGETREPORTLIST_ENDDATE = 'BUDGETREPORTLIST_ENDDATE';

